import React, { useState } from 'react'
import Navbar from '../Components/Navigation/Navbar'
import { LocationProvider } from '../Geolocation/LocationProvider'
import { Select } from '../styling/StyledComponents'
import MapSelector from '../Components/MapSelector'
import Footer from '../Components/Footer/Footer'
import DataFilter from '../Components/DataFilter'

function AdminPage() {
  const [mapType, setMapType] = useState('regular')
  const [selectedProjectId, setSelectedProjectId] = useState('')
  const [selectedQuestionId, setSelectedQuestionId] = useState('')

  return (
    <div className='box'>
      <Navbar />
      <div className='box'>
        <LocationProvider>
          {/* Filter Component */}
          <DataFilter
            selectedProjectId={selectedProjectId}
            setSelectedProjectId={setSelectedProjectId}
            selectedQuestionId={selectedQuestionId}
            setSelectedQuestionId={setSelectedQuestionId}
          />

          {/* Map type selector */}
          <Select className='small-width overlay' onChange={e => setMapType(e.target.value)}>
            <option value="regular">3D Map</option>
            <option value="heatmap2">2D Heatmap</option>
          </Select>

          {/* Map component */}
          <MapSelector
            mapType={mapType}
            selectedProjectId={selectedProjectId}
            selectedQuestionId={selectedQuestionId}
            className='overlay'
          />
        </LocationProvider>
      </div>
      <Footer />
    </div>
  )
}

export default AdminPage
